import type { Environment } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const PACKAGE_NAME = 'jiraServicedeskWidgetSettings';
export const TEAM_NAME = 'itops-mithril';
export const WIDGET_SERVICE_BASE_URL = '/gateway/api/jsm/widget';
export const WIDGET_SERVICE_API_BASE_URL = `${WIDGET_SERVICE_BASE_URL}/api/v2`;

export const WIDGET_SERVICE_ASSETS_BASE_URL: Record<Environment, string> = {
	prod: 'https://jsd-nutmeg.services.atlassian.com',
	staging: 'https://jsd-nutmeg.stg.services.atlassian.com',
	local: 'https://jsd-nutmeg.stg.services.atlassian.com',
	dev: 'https://jsd-nutmeg.stg.services.atlassian.com',
};

export const WIDGET_FEDRAMP_SERVICE_ASSETS_BASE_URL: Record<Environment, string> = {
	prod: 'https://jsd-nutmeg.services.atlassian-us-gov-mod.com',
	staging: 'https://jsd-nutmeg.stg.services.atlassian-us-gov-mod.com',
	local: 'https://jsd-nutmeg.stg.services.atlassian-us-gov-mod.com',
	dev: 'https://jsd-nutmeg.stg.services.atlassian-us-gov-mod.com',
};
